/**
 * Insurance Companies Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageUsersComponent,
  AsyncAddUserComponent,
  AsyncModifyUserComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageUsersComponent}
      />
      <Route path={`${match.url}/create`} component={AsyncAddUserComponent} />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifyUserComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
